/**
 * Created by koqiui on 2017-04-09.
 */
import { Vue, MsgBox } from '../../app.vues'
//
import SwbRealComBankAcctSave from './RealComBankAcctSave';
Vue.regist(SwbRealComBankAcctSave);

//银行账户
export function showSwbRealComBankAcctSaveDialog(dlgArgs, callback, thisArg) {
    let id = dlgArgs['id'] != null ? dlgArgs['id'] : null;
    let realComId = dlgArgs['realComId'] != null ? dlgArgs['realComId'] : null;
    let theDlg = Vue.$showDialog({
        title: id != null ? '银行账户 - 修改' : '银行账户 - 新增',
        width: 600,
        height: 700,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-real-com-bank-acct-save :id="id" :realComId="realComId" ref="swb_real_com_bank_acct_save"></swb-real-com-bank-acct-save>',
        data: {
            id: id,
            realComId: realComId,
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_real_com_bank_acct_save.getResult() || {};
            if(result.type == "info") {
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbRealComBankAcctListSelect from './RealComBankAcctListSelect';
Vue.regist(SwbRealComBankAcctListSelect);

// 选择银行账户
export function selectRealComBankAcctDialog(dlgArgs, callback) {
    let realComId = dlgArgs['realComId'] || null;
    let checkBox = dlgArgs['checkBox'] || null;
    let usage = dlgArgs['usage'] || null;
    let theDlg = Vue.$showDialog({
        title: '银行账户 - 选择',
        width: -400,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-real-com-bank-acct-list-select :checkBox="checkBox" :realComId="realComId" :usage="usage" ref="swb_real_com_bank_acct_list_select"></swb-real-com-bank-acct-list-select>',
        data: {
            checkBox: checkBox,
            realComId: realComId,
            usage: usage
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_real_com_bank_acct_list_select.getDlgResult() || {};
            if(result.type == "info") {
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/merchtFinac/selectDlg.js
// module id = 192
// module chunks = 1